import styled from 'styled-components'

export const DetailCard = styled.div`
  display: flex;
  flex: 1;
  width: 235px;
  height: 80px;
  border: 1px solid #b7b7b7;
  border-radius: 5px;
  padding: 20px;
  gap: 20px;
  @media (max-width: 952px) {
    height: 67px;
    align-items: center;
  }
  @media (max-width: 585px) {
    width: 100%;
  }
`;

export const IconDetailContainer = styled.div`
  display: flex; 
  align-items: center;
`;

export const TextDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const ValueContainer = styled.div`
  display: flex;
  gap: 5px;
`


export const Cipher = styled.p`
  font-size: 14px;
  font-weight: 700;
`

export const DetailText = styled.h1`
  font-size: 12px;
  font-weight: 500;
  color: #929292;
`;

export const ValueText = styled.h1`
  font-size: 20px;
  font-weight: 700;
`;
